<template>
  <div class="test">
    <input id="file" type="file" />
  </div>
</template>

<script>
let OSSFile = require("ali-oss");
export default {
  mounted() {
    document.getElementById("file").addEventListener("change", function (e) {
      let file = e.target.files[0];
      console.log(file);
      let name = file.name;
      // let client = new OSSFile({
      //   accessKeyId: "LTAI4GABDW8Qk3eE9wbhvAft",
      //   accessKeySecret: "VxOZ1Nn2drEuS8mNTlIXXiTRW6C8qB",
      //   region: "oss-cn-beijing",
      //   bucket: "stark-pxo-cn",
      // });
      // async function putObject() {
      //   try {
      //     // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
      //     let result = await client.put("pp", file);
      //     console.log(result);
      //   } catch (e) {
      //     console.log(e);
      //   }
      // }
      // putObject();

      //***************************************** */
      let ossConfig = {
        accessKeyId: "LTAI4GABDW8Qk3eE9wbhvAft",
        accessKeySecret: "VxOZ1Nn2drEuS8mNTlIXXiTRW6C8qB",
        region: "oss-cn-beijing",
        bucket: "stark-pxo-cn",
      };

      let client = new OSSFile(ossConfig);
      let tempCheckpoint;
      // 定义上传方法。
      async function multipartUpload() {
        console.log(444);
        try {
          console.log("try");
          // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
          let result = await client.multipartUpload(name, file, {
            progress: function (p, checkpoint) {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              tempCheckpoint = checkpoint;
            },
            meta: { year: 2020, people: "test" },
          });
          console.log(result);
        } catch (e) {
          console.log(e);
        }
      }

      // 开始分片上传。
      multipartUpload();

      // 暂停分片上传。
      // client.cancel();

      // 恢复上传。
      let resumeclient = new OSS(ossConfig);
      async function resumeUpload() {
        try {
          let result = await resumeclient.multipartUpload(
            "object-key",
            "file-object",
            {
              progress: function (p, checkpoint) {
                tempCheckpoint = checkpoint;
              },
              checkpoint: tempCheckpoint,
              meta: { year: 2020, people: "test" },
            }
          );
        } catch (e) {
          console.log(e);
        }
      }

      // resumeUpload();
    });
  },
};
</script>

<style>
</style>